import appConfig from '../../shared/helpers/appConfig';
import { FEATURE_FLAGS } from '../featureFlags';

/**
 * Whether this account actually uses organization instead of the legacy
 * branch feature — driven entirely by the `organization` feature flag (the
 * default for new accounts, see config/features.yml; existing accounts are
 * migrated via `bundle exec rake organization:migrate_legacy_accounts`).
 * No development-mode bypass: this drives which accounts have branches
 * hidden/blocked, and must stay accurate for every account locally so
 * branches remains testable in development.
 *
 * @param {Object} store - Vuex store instance
 * @param {String} accountId - Account ID from route params
 * @returns {Boolean}
 */
export function isOrganizationAccount(store, accountId) {
  return store.getters['accounts/isFeatureEnabledonAccount'](
    accountId,
    FEATURE_FLAGS.ORGANIZATION
  );
}

/**
 * Single source of truth for granting access to the organization feature
 * itself (route guards, sidebar nav item). Also allows any account in a
 * development environment, so the feature stays easy to test locally
 * without needing the flag enabled.
 *
 * Consumed by the organization route guards and the organization sidebar
 * nav item. For "should legacy branches be hidden for this account" use
 * isOrganizationAccount instead — it deliberately has no dev-mode bypass.
 *
 * @param {Object} store - Vuex store instance
 * @param {String} accountId - Account ID from route params
 * @returns {Boolean}
 */
export function hasOrganizationAccess(store, accountId) {
  if (appConfig('VUE_APP_ENV') === 'development') {
    return true;
  }

  return isOrganizationAccount(store, accountId);
}
